/* Klaviyo rich text uses injected HTML. Only noninteractive form headings change. */
(() => {
  const selector = '.klaviyo-form-richtext h1';
  const normalize = (root) => {
    const headings = [];
    if (root.matches && root.matches(selector)) headings.push(root);
    if (root.querySelectorAll) headings.push(...root.querySelectorAll(selector));
    for (const heading of headings) {
      if (!heading.isConnected || heading.querySelector('input, button, a, select, textarea')) continue;
      const replacement = document.createElement('h2');
      for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
      // Preserve computed typography and spacing across the tag change.
      const style = getComputedStyle(heading);
      for (const property of ['font-family', 'font-size', 'font-weight', 'font-style', 'line-height', 'letter-spacing', 'text-transform', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left']) {
        replacement.style.setProperty(property, style.getPropertyValue(property));
      }
      while (heading.firstChild) replacement.appendChild(heading.firstChild);
      heading.replaceWith(replacement);
    }
  };
  normalize(document);
  new MutationObserver((records) => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) normalize(node);
  }).observe(document.body, { childList: true, subtree: true });
})();
